export const APPRAISER_STYLE_PAGE_NAME = 'used_model_mydp_tmv_appraiser_style';
export const APPRAISER_STYLE_HIGHLIGHTS_PAGE_NAME = 'used_model_mydp_tmv_appraiser_style_highlights';
